import React from 'react';
import { motion } from 'framer-motion';
const ApplyButton = () => {
  const scrollToTypeform = () => {
    const typeformSection = document.getElementById('typeform-section');
    if (typeformSection) {
      typeformSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <div className="flex justify-center" data-id="element-42">
      <div className="relative" data-id="element-43">
        <div className="button-border-light" data-id="element-44"></div>
        <motion.button onClick={scrollToTypeform} whileHover={{
        scale: 1.05,
        boxShadow: '0px 8px 20px rgba(255, 223, 7, 0.3)'
      }} className="relative z-10 bg-gradient-to-r from-[#ffdf07] via-[#fae651] to-[#ffdf07] text-black font-semibold py-3 sm:py-4 px-8 sm:px-12 rounded-md text-base sm:text-lg shadow-[0_4px_14px_rgba(255,223,7,0.25)] border border-[#ffd70077] transition-all duration-300" data-id="element-45">
          Get My Free Consult
        </motion.button>
      </div>
    </div>;
};
export default ApplyButton;